import Cookie from 'js-cookie';
import superagent from 'superagent';
import { AUTH_API_SETTINGS } from 'services/App/App.constants';

// eslint-disable-next-line import/no-cycle
import receiptsModel from 'models/receipts';
import imageCacheModel from 'models/imageCache';

const REQUEST_TIME = 60 * 1000; // seconds

export default class ReceiptsGet {
  constructor() {
    this.requestStarted = false;
  }

  // https://stackoverflow.com/questions/32702431/display-images-fetched-from-s3
  static encode(data) {
    const str = data.reduce((a, b) => a + String.fromCharCode(b), '');
    return btoa(str).replace(/.{76}(?=.)/g, '$&\n');
  }

  list(page = 1, force = false) {
    // get this every time since the session/settings/token always change
    const accessToken = Cookie.get('accessToken');
    const country = 'JP';

    return new Promise((resolve, reject) => {
      //  skip request if previous request is still ongoing unless force reload is enabled
      if (!force && this.requestStarted) {
        return resolve();
      }

      // setup timer
      this.requestStarted = true;

      window.setTimeout(
        () => {
          this.requestStarted = false;
        },
        REQUEST_TIME
      );

      return superagent
        .get(`${AUTH_API_SETTINGS[country].API_BASE_URL}/v8/api/web/presenter/uploads.json?page=${page}`)
        .set('authorization', `Bearer ${accessToken}`)
        .set('x-api-version', 6)
        .end(async (error, response) => {
          if (error || response.status !== 200) {
            console.error(`Error fetching the list of uploads. Error: ${error}`);

            return reject();
          }

          const { body } = response;

          const isFullPage = await receiptsModel.updateContent(body.uploads);

          this.requestStarted = false;

          return resolve(isFullPage);
        });
    });
  }

  getThumbnailKey(s3Key) {
    let thumbnailKey = s3Key.split('.');
    thumbnailKey.pop();
    thumbnailKey = `${thumbnailKey.join('.')}.png`;
    thumbnailKey = thumbnailKey.split('/');
    thumbnailKey = `${thumbnailKey[0]}/thumbnail/${thumbnailKey[1]}`;
    return thumbnailKey;
  }

  imageByID(receiptID, presignedUrls, isThumbnail = false) {
    let image;

    if (isThumbnail) {
      const receipt = receiptsModel.receipts[receiptID];
      // try to get local thumbnail image if available
      if (receipt && receipt.thumbnailKey) {
        image = imageCacheModel.get(receipt.thumbnailKey);
      }
    }

    // get local image if there is no thumbnail or image available
    if (!image) {
      image = imageCacheModel.get(receiptID);
    }

    // grab image from aws if image doesn't exists in local cache
    return new Promise((resolve, reject) => {
      if (image) {
        resolve(image);
        return;
      }

      if (presignedUrls) {
        const { url, thumbnail_url: thumbnailUrl } = presignedUrls
        const imageUrl = isThumbnail ? thumbnailUrl : url;
        const receiptCacheKey = isThumbnail ? this.getThumbnailKey(receiptID) : receiptID;

        fetch(imageUrl)
          .then(response => response.blob())
          .then(blob => {
            const blobUrl = URL.createObjectURL(blob);
            imageCacheModel.add(receiptCacheKey, blobUrl);
            resolve(blobUrl);
          })
          .catch(error => {
            console.error('Error fetching image from URL:', error);
            return reject();
          });
      }
    });
  }
}
